import { Application } from "@hotwired/stimulus"
import Dropdown from '@stimulus-components/dropdown'
import Popover from '@stimulus-components/popover'
import Carousel from '@stimulus-components/carousel'
import Dialog from '@stimulus-components/dialog'

const application = Application.start()
application.register('dropdown', Dropdown)
application.register('popover', Popover)
application.register('carousel', Carousel)
application.register('dialog', Dialog)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
